/*
  Avísame cuando haya talla (back in stock) de Hermanos Koumori.
  Va de la mano con snippets/hk-back-in-stock.liquid.

  Qué hace:
  1. Observa la variante elegida en el formulario de compra (input name="id" y el botón
     de agregar al carrito) y muestra el botón cuando esa talla está agotada.
  2. Al enviar el correo lo registra en Klaviyo como evento propio "Pidio aviso de talla"
     (Client API, llave publica) con producto, talla, SKU, precio, foto, liga, mercado, pais
     e idioma, y deja mercado/pais/idioma como propiedades del perfil.
  3. El aviso lo dispara el bot AvisameTalla.gs (Apps Script "Alertas Tiendas"), que
     vigila solo la bodega online y manda a Klaviyo el evento "Volvio la talla"; el flujo
     de Klaviyo con ese disparador envia el correo. No se usa el back in stock nativo de
     Klaviyo porque suma el inventario de las tiendas, que no surten pedidos online.

  Nota: Baseline actualiza el formulario por JS al cambiar de talla y a veces tarda
  cerca de un segundo (trae la sección del servidor). Por eso cada interacción programa
  varias revisiones escalonadas y además se observan los atributos del formulario.
*/
(function () {
  if (window.customElements.get('hk-back-in-stock')) return;

  var KLAVIYO_EVENTS_URL = 'https://a.klaviyo.com/client/events';
  var EVENT_METRIC = 'Pidio aviso de talla';
  var KLAVIYO_REVISION = '2024-10-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var CHECK_DELAYS = [60, 300, 800, 1500, 2500];

  function fill(text, vars) {
    return String(text || '').replace(/\{(\w+)\}/g, function (m, k) {
      return vars[k] != null ? vars[k] : m;
    });
  }

  // Evento propio en Klaviyo con el mercado: el evento nativo de back in stock no lo trae.
  // Lleva unique_id por talla, correo y dia para que un doble clic no cuente dos veces.
  function trackSubscription(el, email, variantId) {
    var v = el.variants[variantId] || {};
    var d = el.dataset;
    var today = new Date().toISOString().slice(0, 10);
    var body = {
      data: {
        type: 'event',
        attributes: {
          properties: {
            ProductName: d.productTitle || '', ProductID: d.productId || '', ProductHandle: d.productHandle || '',
            VariantId: String(variantId), Size: v.size || '', SKU: v.sku || '', PriceText: v.price || '',
            Market: d.market || '', Country: d.country || '', Language: d.language || '',
            ProductURL: (d.productUrl || window.location.href.split('?')[0]) + '?variant=' + variantId,
            ImageURL: d.imageUrl || '', URL: window.location.href.split('?')[0], Source: 'hk-back-in-stock'
          },
          unique_id: 'bis-' + variantId + '-' + today + '-' + email.toLowerCase(),
          metric: { data: { type: 'metric', attributes: { name: EVENT_METRIC } } },
          profile: { data: { type: 'profile', attributes: {
            email: email,
            properties: { 'BIS Market': d.market || '', 'BIS Country': d.country || '', 'BIS Language': d.language || '' }
          } } }
        }
      }
    };
    return fetch(KLAVIYO_EVENTS_URL + '?company_id=' + encodeURIComponent(el.companyId), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(body)
    });
  }

  function HKBackInStock() {
    return Reflect.construct(HTMLElement, [], HKBackInStock);
  }
  HKBackInStock.prototype = Object.create(HTMLElement.prototype);
  HKBackInStock.prototype.constructor = HKBackInStock;
  Object.setPrototypeOf(HKBackInStock, HTMLElement);

  HKBackInStock.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;

    try {
      this.variants = JSON.parse(this.dataset.variants || '{}');
      this.t = JSON.parse(this.dataset.strings || '{}');
    } catch (e) {
      this.variants = {};
      this.t = {};
    }
    this.companyId = this.dataset.companyId;
    this.section = this.closest('.shopify-section') || document;
    this._timers = [];

    this.cta = this.querySelector('[data-bis-cta]');
    this.panel = this.querySelector('[data-bis-panel]');
    this.label = this.querySelector('[data-bis-label]');
    this.form = this.querySelector('[data-bis-form]');
    this.input = this.querySelector('[data-bis-input]');
    this.inputLabel = this.querySelector('[data-bis-input-label]');
    this.submitBtn = this.querySelector('[data-bis-submit]');
    this.note = this.querySelector('[data-bis-note]');
    this.status = this.querySelector('[data-bis-status]');

    this.input.placeholder = this.t.placeholder || '';
    this.inputLabel.textContent = this.t.placeholder || '';
    this.submitBtn.textContent = this.t.submit || '';
    this.note.textContent = this.t.note || '';

    var self = this;
    this.cta.addEventListener('click', function () { self.open(); });
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      self.submit();
    });

    var bump = function () { self.scheduleChecks(); };
    this.section.addEventListener('change', bump, true);
    this.section.addEventListener('click', bump, true);
    window.addEventListener('popstate', bump);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () { self.evaluate(); });
      var productForm = this.productForm();
      if (productForm) {
        observer.observe(productForm, { attributes: true, childList: true, subtree: true, attributeFilter: ['value', 'class', 'disabled'] });
      }
      var atc = this.atcButton();
      if (atc) {
        observer.observe(atc, { attributes: true, attributeFilter: ['class', 'disabled'] });
      }
    }

    this.evaluate();
  };

  HKBackInStock.prototype.productForm = function () {
    return this.section.querySelector('form[data-product-form]');
  };

  HKBackInStock.prototype.atcButton = function () {
    return this.section.querySelector('button.main-product-atc.add-to-cart') || this.section.querySelector('button.main-product-atc');
  };

  HKBackInStock.prototype.scheduleChecks = function () {
    var self = this;
    this._timers.forEach(clearTimeout);
    this._timers = CHECK_DELAYS.map(function (ms) {
      return setTimeout(function () { self.evaluate(); }, ms);
    });
  };

  HKBackInStock.prototype.currentVariant = function () {
    var form = this.productForm();
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var id = idInput ? String(idInput.value || '') : '';
    if (!id) {
      var url = new URL(window.location.href);
      id = url.searchParams.get('variant') || '';
    }
    if (!id || !this.variants[id]) return null;
    var v = this.variants[id];
    return { id: id, available: v.available, size: v.size };
  };

  HKBackInStock.prototype.evaluate = function () {
    var v = this.currentVariant();
    var soldOut = !!(v && v.available === false);
    var atc = this.atcButton();
    if (soldOut && atc && !atc.disabled && !atc.classList.contains('is-sold-out')) {
      // El tema dice que sí se puede comprar: le creemos al tema.
      soldOut = false;
    }
    if (!soldOut) {
      this.classList.remove('is-active');
      return;
    }
    if (this.variantId !== v.id) {
      this.variantId = v.id;
      this.size = v.size;
      this.render();
      // Cambió la talla: se limpia el resultado anterior, pero el panel se queda como estaba.
      this.classList.remove('is-done');
      this.setStatus('', false);
      this.submitBtn.disabled = false;
      this.submitBtn.textContent = this.t.submit || '';
    }
    this.classList.add('is-active');
  };

  HKBackInStock.prototype.render = function () {
    var vars = { size: this.size || '' };
    var hasSize = !!this.size;
    this.cta.textContent = fill(hasSize ? this.t.cta : this.t.cta_nosize, vars);
    this.label.textContent = fill(hasSize ? this.t.label : this.t.label_nosize, vars);
  };

  HKBackInStock.prototype.open = function () {
    this.classList.add('is-open');
    this.cta.setAttribute('aria-expanded', 'true');
    var self = this;
    setTimeout(function () { self.input.focus(); }, 30);
  };

  HKBackInStock.prototype.setStatus = function (text, isError) {
    this.status.textContent = text || '';
    this.status.classList.toggle('is-visible', !!text);
    this.status.classList.toggle('is-error', !!isError);
  };

  HKBackInStock.prototype.submit = function () {
    var email = (this.input.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      this.setStatus(this.t.invalid, true);
      this.input.focus();
      return;
    }
    var variantId = this.variantId;
    if (!variantId) {
      this.setStatus(this.t.error, true);
      return;
    }
    var self = this;
    this.submitBtn.disabled = true;
    this.submitBtn.textContent = this.t.sending || this.t.submit;
    this.setStatus('', false);

    trackSubscription(self, email, variantId).then(function (res) {
      if (!res.ok) throw new Error('klaviyo ' + res.status);
      if (self.variantId !== variantId) return; // cambió de talla mientras guardaba
      self.classList.add('is-done');
      var hasSize = !!self.size;
      self.setStatus(fill(hasSize ? self.t.success : self.t.success_nosize, { email: email, size: self.size || '' }), false);
      document.dispatchEvent(new CustomEvent('hk:back-in-stock:subscribed', {
        detail: { email: email, variantId: variantId, productId: self.dataset.productId, size: self.size }
      }));
    }).catch(function () {
      self.submitBtn.disabled = false;
      self.submitBtn.textContent = self.t.submit || '';
      self.setStatus(self.t.error, true);
    });
  };

  window.customElements.define('hk-back-in-stock', HKBackInStock);
})();
